/*
 * @Author: your name
 * @Date: 2022-01-12 10:39:44
 * @LastEditTime: 2022-01-12 11:14:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\store\index.js
 */
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducer";
const initState = 0;
const middleware = [thunk];

const store = createStore(
  reducer,
  initState,
  compose(applyMiddleware(...middleware))
);

export default store;
